import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5 21L7.5 12L16.5 3", stroke: "#121212", strokeWidth: 1.5, strokeMiterlimit: 10 }));
export default SvgArrow;
